<template>
    <v-container style="max-width: 900px">
		<div class="text-center">
           <h1>
                An error occurred
           </h1>
       </div>
    </v-container>
</template>
<script>
	export default {
		components: {},

		data() {
			return {};
		}
	};
</script>
